const $win = $(window);
const $doc = $(document);

$(() => {
  $('.slick-syncing').slick_syncing();

  $('.archive-year').each(function() {
    var year_list = $(this);
    year_list.find('> a').on('click', function(e){
      // use conditon with e.detail to prevent double click bounces in slideToggle()
      if(!e.detail || e.detail==1){
        year_list.find('> a').toggleClass('toggle-collapse');
        year_list.find('.archive-months').slideToggle('fast');
      }
    });
  });

  $('li.archive-month').each(function(){
    var archive_link = $(this).find('.timeline-link');
    // if the current path is like this link, make it active
    if(window.location.href.indexOf(archive_link.attr('href')) !== -1){
      archive_link.parent().addClass('active');
      $(this).closest('.archive-year').addClass('active');
    }
  });
});

$win.on('load', () => {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $('ul.news-archive').each(function() {
      var list = $(this),
      select = $(document.createElement('select')).insertBefore($(this).hide()).on('change', function(){
        window.location.href=$(this).val();
      });
      $('li a', this).each(function(){
        var option = $(document.createElement('option'))
        .appendTo(select)
        .val(this.href)
        .html($(this).html());
        if($(this).parent().hasClass('archive-year')){
          option.attr('disabled','disabled');
        }
        if($(this).parent().hasClass('archive-month')){
          option.addClass('child-option');
          option.html('&nbsp;&nbsp; - ' + option.text());
        }
        if($(this).parent('.archive-month').hasClass('active')){
          option.attr('selected','selected');
        }
      });
      list.remove();
    });
  }
});
